"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleFetch = exports.getConfigFromUser = exports.reloadConfig = void 0;
var helper_1 = require("../utils/helper");
var __1 = require("..");
// 定义一个处理请求的函数
var handleFetch = function (url) {
    return fetch("".concat(url, "?time=").concat(new Date().valueOf())).then(function (res) { return res.json(); }, function (rej) {
        console.warn(rej);
        throw Error("Elvish Warning: fetch ".concat(url, " error"));
    });
};
function reloadConfig(callback, isTest) {
    var intervalTime = isTest ? 5000 : 1000 * 60 * 2;
    var retry = 0;
    var timeout = null;
    var loopRetry = function () {
        return Promise.all([
            handleFetch(helper_1.apolloCDNPath),
            handleFetch(helper_1.cityMapCDNPath),
            handleFetch(helper_1.countryTimezoneCDNPath),
            handleFetch(helper_1.timezoneCDNPath)
        ])
            .then(function (_a) {
            var apollo = _a[0], cityMap = _a[1], countryTimezone = _a[2], timezone = _a[3];
            callback({ apollo: apollo, cityMap: cityMap, countryTimezone: countryTimezone, timezone: timezone });
        })
            .catch(function () {
            retry += 1;
            if (retry >= 3) {
                retry = 0;
                callback(false);
            }
            else {
                timeout && clearTimeout(timeout);
                timeout = setTimeout(function () {
                    console.log("\u6B63\u5728\u91CD\u8BD5\u7B2C".concat(retry, "\u6B21"));
                    loopRetry();
                }, intervalTime);
            }
        });
    };
    return loopRetry();
}
exports.reloadConfig = reloadConfig;
var getConfigFromUser = function (locale, country, config) {
    if (config === void 0) { config = {}; }
    var apollo = config.apollo, cityMap = config.cityMap, countryTimezone = config.countryTimezone, timezone = config.timezone;
    if (typeof locale !== 'string') {
        return Promise.reject(new Error("Elvish Error: Incorrect locale params"));
    }
    if (apollo && cityMap && countryTimezone && timezone) {
        return (0, __1.initV2)({
            locale: locale,
            country: country,
            config: config,
            options: { forceInit: true }
        });
    }
    return Promise.reject(new Error("Elvish Error: Incorrect config data"));
};
exports.getConfigFromUser = getConfigFromUser;
var scheduleFetch = function (callback) {
    var fetchConfig = function () {
        try {
            reloadConfig(callback);
        }
        catch (e) {
            console.warn(e);
            callback(false);
        }
    };
    var scheduleNextFetch = function () {
        var now = new Date();
        var nextFetchTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        var timeUntilNextFetch = nextFetchTime.getTime() - now.getTime();
        setTimeout(function () {
            fetchConfig();
            scheduleNextFetch();
        }, timeUntilNextFetch);
        console.log('下次拉取接口配置将在', nextFetchTime);
    };
    fetchConfig();
    scheduleNextFetch();
};
exports.scheduleFetch = scheduleFetch;
